import React, { useEffect, useState } from "react";
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormGroup,
  CImg,
  CInput,
  CInputCheckbox,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";

import api from "../../utils/api";

//* COMMENT: PUBLIC PAGE (NO LOGIN) FOR THE PLAY STORE ACCOUNT-DELETION
//* REQUIREMENT. SAME DELETION AS THE APP'S "DELETE ACCOUNT", GATED BY AN OTP
//* THAT IS VERIFIED ON THE SERVER.
const RESEND_SECONDS = 30;

const apiError = (err, fallback) =>
  err.response?.data?.message || err.response?.data?.error || fallback;

const DeleteAccount = () => {
  const [step, setStep] = useState("mobile"); // mobile | otp | done
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setTimeout(() => setCooldown(cooldown - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  const sendOtp = async (e) => {
    if (e) e.preventDefault();
    setError("");
    setInfo("");
    if (!/^[0-9]{10}$/.test(mobile)) {
      return setError("Enter your 10 digit mobile number");
    }
    setBusy(true);
    try {
      const res = await api.post("/customer/delete/otp", { mobile });
      setInfo(res.data.message || "OTP sent to your mobile number");
      setStep("otp");
      setOtp("");
      setCooldown(RESEND_SECONDS);
    } catch (err) {
      setError(apiError(err, "Could not send OTP. Please try again."));
    }
    setBusy(false);
  };

  const confirmDelete = async (e) => {
    e.preventDefault();
    setError("");
    setInfo("");
    if (!/^[0-9]{4}$/.test(otp)) {
      return setError("Enter the 4 digit OTP sent to your mobile");
    }
    if (!confirmed) {
      return setError("Please confirm that you understand this is permanent");
    }
    setBusy(true);
    try {
      await api.post("/customer/delete/confirm", { mobile, otp });
      setStep("done");
    } catch (err) {
      setError(apiError(err, "Could not delete the account. Please try again."));
    }
    setBusy(false);
  };

  return (
    <div
      className="c-app c-default-layout flex-row align-items-center"
      style={{
        background: `url('/images/bg.png')`,
        backgroundRepeat: `no-repeat`,
        objectFit: `contain`,
      }}
    >
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="9" lg="8">
            <CCardGroup
              style={{ boxShadow: "0px 0px 10px", borderRadius: "10px" }}
            >
              <CCard
                className="text-white py-5 d-md-down-none d-flex justify-content-center align-items-center"
                style={{ width: "40%" }}
              >
                <CImg src="/images/logo/loginlogo.png" width="140" height="140" />
              </CCard>

              <CCard className="p-4">
                <CCardBody>
                  <h1>Delete your Ausmart account</h1>

                  {step === "done" ? (
                    <>
                      <CAlert color="success" className="mt-3">
                        Your account has been deleted successfully.
                      </CAlert>
                      <p className="text-muted">
                        You can uninstall the Ausmart app now. If you ever want
                        to come back, simply register again with your mobile
                        number.
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="text-muted">
                        This permanently deletes the account registered with
                        your mobile number in the Ausmart customer app. To
                        confirm it is you, we will send a one-time password
                        (OTP) to that number.
                      </p>

                      <div
                        className="mb-3 p-3"
                        style={{
                          background: "#f6f7f9",
                          borderRadius: "8px",
                          fontSize: "13px",
                        }}
                      >
                        <strong>What is deleted:</strong> your profile, saved
                        addresses and login. You will no longer be able to sign
                        in with this number.
                        <br />
                        <strong>What is retained:</strong> records of orders you
                        have already placed are kept for accounting and legal
                        purposes.
                      </div>

                      {error && <CAlert color="danger">{error}</CAlert>}
                      {info && <CAlert color="info">{info}</CAlert>}

                      {step === "mobile" && (
                        <CForm method="post" onSubmit={sendOtp}>
                          <CInputGroup className="mb-3">
                            <CInputGroupPrepend>
                              <CInputGroupText>+91</CInputGroupText>
                            </CInputGroupPrepend>
                            <CInput
                              type="tel"
                              inputMode="numeric"
                              placeholder="Registered mobile number"
                              autoComplete="tel-national"
                              value={mobile}
                              maxLength={10}
                              onChange={(e) =>
                                setMobile(e.target.value.replace(/\D/g, ""))
                              }
                              required
                            />
                          </CInputGroup>
                          <CButton
                            style={{ backgroundColor: "#363b4a", color: "white" }}
                            block
                            type="submit"
                            disabled={busy}
                          >
                            {busy ? "Sending OTP..." : "Send OTP"}
                          </CButton>
                        </CForm>
                      )}

                      {step === "otp" && (
                        <CForm method="post" onSubmit={confirmDelete}>
                          <p className="mb-2">
                            OTP sent to <strong>+91 {mobile}</strong>{" "}
                            <CButton
                              color="link"
                              className="p-0 align-baseline"
                              onClick={() => {
                                setStep("mobile");
                                setError("");
                                setInfo("");
                              }}
                            >
                              change
                            </CButton>
                          </p>
                          <CInputGroup className="mb-3">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <CIcon name="cil-lock-locked" />
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <CInput
                              type="text"
                              inputMode="numeric"
                              placeholder="4 digit OTP"
                              autoComplete="one-time-code"
                              value={otp}
                              maxLength={4}
                              onChange={(e) =>
                                setOtp(e.target.value.replace(/\D/g, ""))
                              }
                              required
                            />
                          </CInputGroup>

                          <CFormGroup variant="custom-checkbox" className="mb-3">
                            <CInputCheckbox
                              custom
                              id="confirmDelete"
                              checked={confirmed}
                              onChange={(e) => setConfirmed(e.target.checked)}
                            />
                            <CLabel variant="custom-checkbox" htmlFor="confirmDelete">
                              I understand my account will be permanently
                              deleted and this cannot be undone.
                            </CLabel>
                          </CFormGroup>

                          <CButton
                            color="danger"
                            block
                            type="submit"
                            disabled={busy || !confirmed}
                          >
                            {busy ? "Deleting..." : "Delete my account"}
                          </CButton>

                          <div className="text-center mt-3">
                            <CButton
                              color="link"
                              className="p-0"
                              disabled={busy || cooldown > 0}
                              onClick={() => sendOtp()}
                            >
                              {cooldown > 0
                                ? `Resend OTP in ${cooldown}s`
                                : "Resend OTP"}
                            </CButton>
                          </div>
                        </CForm>
                      )}
                    </>
                  )}
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default DeleteAccount;
